export default {
    lang: {
        name: 'Date added'
    }
}